import { FluidOwaSource, FluidOwaScenario, FluidOwaSourceNames } from 'owa-fluid-validations';
import { FluidOwaScenarioNames } from './constants';

export function getScenarioNameFromScenarioAndSource(
    scenario: FluidOwaScenario,
    owaSource: FluidOwaSource
): string {
    switch (scenario) {
        case FluidOwaScenario.MAIL_READINGPANE_SCENARIO:
        case FluidOwaScenario.CALENDAR_READ_SCENARIO:
        case FluidOwaScenario.CALENDAR_CREATE_NEW:
            return FluidOwaSourceNames[owaSource];
        default:
            return FluidOwaScenarioNames[scenario];
    }
}
